export default __webpack_public_path__ + "static/media/gmail.dcbc3510.png";